module.exports = __webpack_public_path__ + "static/media/share.f8987cd7.svg";


//////////////////
// WEBPACK FOOTER
// ../thicket/packages/thicket-elements/images/share.svg
// module id = 123
// module chunks = 2